import { deleteDoc, doc, updateDoc } from 'firebase/firestore';
import React, { useState } from 'react';
import { db } from '../firebase';
import { getSpellId } from '../util/spell';

export const ActiveListContext = React.createContext();

export const ActiveListProvider = ({ children }) => {
    const [ activeList, setActiveList ] = useState(null);

    const updateField = (key, value) => {
        const docRef = doc(db, "spellLists", activeList.id);

        updateDoc(docRef, {
            [key]: value
        }).then(() => {
            setActiveList(a => ({
                ...a,
                [key]: value
            }))
        });
    };

    const deleteList = () => {
        const docRef = doc(db, "spellLists", activeList.id);

        deleteDoc(docRef).then(() => {
            setActiveList(null);
        });
    };

    const addSpell = (spell) => {
        if (!activeList || !spell) return;

        const newSpells = [...new Set([
            ...activeList.spells,
            getSpellId(spell)
        ])];

        updateField('spells', newSpells);
    };

    const hasSpell = (spell) => {
        if (!activeList || !spell) return;

        return activeList.spells.includes(getSpellId(spell));
    };

    const removeSpell = (spell) => {
        if (!activeList || !spell) return;

        const newSpells = activeList.spells.filter(s => s !== getSpellId(spell));

        updateField('spells', newSpells);
    };

    const prepareSpell = (spell) => {
        if (!activeList || !spell) return;

        const newValue = [...new Set([
            ...(activeList.prepared || []),
            getSpellId(spell)
        ])];

        updateField('prepared', newValue);
    };

    const isPrepared = (spell) => {
        if (!activeList || !spell) return;

        return activeList?.prepared?.includes(getSpellId(spell));
    };

    const unprepareSpell = (spell) => {
        if (!activeList || !spell) return;

        const newValue = activeList.prepared.filter(s => s !== getSpellId(spell));

        updateField('prepared', newValue);
    };

    return (
        <ActiveListContext.Provider value={{ 
            activeList,
            setActiveList,
            addSpell,
            hasSpell,
            removeSpell,
            prepareSpell,
            isPrepared,
            unprepareSpell,
            deleteList
         }}>
             {children}
        </ActiveListContext.Provider>
    );
};
